import { useLang } from "@/context/LanguageContext";
import { useDemoForm } from "@/context/DemoFormContext";
import { ASSETS } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { ArrowRight, Phone } from "lucide-react";

export const FinalCTA = () => {
  const { t } = useLang();
  const { openForm } = useDemoForm();
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #1A1A1A 0%, #2A1F3D 60%, #1A1A1A 100%)",
      }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-40 pointer-events-none animate-blob-slow"
        style={{
          background:
            "radial-gradient(50% 50% at 20% 30%, rgba(167,139,250,0.45) 0%, transparent 70%), radial-gradient(50% 50% at 80% 70%, rgba(103,232,249,0.35) 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#67E8F9] mb-7" data-testid="cta-eyebrow">
            {t.final_cta.eyebrow}
          </div>
          <h2
            data-testid="cta-title"
            className="font-serif font-light text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-white max-w-4xl mx-auto"
          >
            {t.final_cta.title}{" "}
            <span className="italic shimmer-text">
              {t.final_cta.title_accent}
            </span>
          </h2>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-7 text-base md:text-lg text-white/70 font-light max-w-2xl mx-auto" data-testid="cta-subtitle">
            {t.final_cta.subtitle}
          </p>
        </Reveal>

        <Reveal delay={280}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <button
              type="button"
              data-testid="cta-primary-button"
              onClick={() => openForm()}
              className="group inline-flex items-center gap-2 bg-gradient-to-r from-[#A78BFA] to-[#67E8F9] text-[#1A1A1A] rounded-full px-8 py-4 text-sm tracking-wide font-medium hover:shadow-[0_0_40px_rgba(167,139,250,0.5)] transition-all"
            >
              {t.final_cta.cta_primary}{" "}
              <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" />
            </button>
            <button
              type="button"
              data-testid="cta-secondary-button"
              onClick={() => openForm()}
              className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white hover:bg-white/15 rounded-full px-8 py-4 text-sm tracking-wide backdrop-blur"
            >
              <Phone size={14} /> {t.final_cta.cta_secondary}
            </button>
          </div>
        </Reveal>

        <Reveal delay={400}>
          <div className="mt-16 inline-flex items-center gap-3 text-white/50 animate-float">
            <img src={ASSETS.logo} alt="" className="h-8 w-8 rounded-full object-contain bg-white/10" />
            <span className="font-serif italic text-lg">AURA</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
